<header class="page-header" data-testid="drawings-page-header">
  <button type="button" class="page-header-back" [attr.aria-label]="backLabel" [attr.data-testid]="backTestId || null" (click)="back.emit()">
    <mat-icon svgIcon="chevron-left" aria-hidden="true" />
  </button>
  <div class="page-header-text">
    <div class="page-header-title-row">
      <h1 class="page-header-title" [attr.data-testid]="titleTestId || null">{{ title }}</h1>
      <ng-content select="[headerMenu]" />
    </div>
    @if (subtitle) {
      <p class="page-header-subtitle" data-testid="drawings-page-header-subtitle">{{ subtitle }}</p>
    }
    <ng-content select="[headerSub]" />
    <div class="page-header-chips"><ng-content select="[headerChips]" /></div>
  </div>
  <div class="page-header-actions"><ng-content select="[headerActions]" /></div>
</header>
